import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_LINKS } from '../config/navigation';
import { containerWide } from '../styles/ui';

const Footer = () => {
  return (
    <footer className="py-14 bg-gradient-to-b from-emerald-950 to-emerald-900 relative overflow-hidden">
      <div
        className="absolute -top-16 left-1/4 w-72 h-72 bg-emerald-700/20 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div className={`${containerWide} relative`}>
        <div className="text-center">
          <p className="serif text-white font-medium text-lg italic">
            "From our store to your home, fresh every day."
          </p>

          <nav aria-label="Footer" className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2">
            {FOOTER_LINKS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="text-sm text-emerald-100 hover:text-white underline underline-offset-4 decoration-emerald-400/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2 focus-visible:ring-offset-emerald-950 rounded"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <p className="text-emerald-300/60 text-xs mt-6 uppercase tracking-widest">
            &copy; 2026 Fresh & Homely. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
